import React from "react";
import { createBrowserRouter } from "react-router-dom";
import { ActiveGoalPage } from "@/apps/goals/pages/ActiveGoalPage/ActiveGoalPage";
import { GoalCompletedPage } from "@/apps/goals/pages/GoalCompletedPage/GoalCompletedPage";
import { GoalFailedPage } from "@/apps/goals/pages/GoalFailedPage/GoalFailedPage";
import { GoalsAppPage } from "@/apps/goals/pages/GoalsAppPage/GoalsAppPage";
import { RegionSelectorPage } from "@/apps/goals/pages/RegionSelectorPage/RegionSelectorPage";
import { WheelPage } from "@/apps/goals/pages/WheelPage/WheelPage";
import { RaffleHistoryPage } from "@/apps/raffle/pages/RaffleHistoryPage/RaffleHistoryPage";
import { RafflePage } from "@/apps/raffle/pages/RafflePage/RafflePage";
import { App } from "@/app/App";
import { RedirectToGoals } from "@/app/RedirectToGoals";
import { PlaygroundPage } from "@/dev/playground/PlaygroundPage";
import { RouteErrorBoundary } from "@/ui/ErrorBoundary/ErrorBoundary";

const routes = [
  {
    element: <App />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: "/",
        element: <RedirectToGoals />,
      },
      {
        path: "/apps/goals",
        element: <GoalsAppPage />,
        children: [
          {
            index: true,
            element: null,
          },
          {
            path: "region",
            element: <RegionSelectorPage />,
          },
          {
            path: "wheel",
            element: <WheelPage />,
          },
          {
            path: "active",
            element: <ActiveGoalPage />,
          },
          {
            path: "completed",
            element: <GoalCompletedPage />,
          },
          {
            path: "failed",
            element: <GoalFailedPage />,
          },
        ],
      },
      {
        path: "/apps/raffle",
        element: <RafflePage />,
      },
      {
        path: "/apps/raffle/history",
        element: <RaffleHistoryPage />,
      },
      {
        path: "/apps/raffle/:bonusId",
        element: <RafflePage />,
      },
    ],
  },
  {
    path: "/playground",
    element: <PlaygroundPage />,
    errorElement: <RouteErrorBoundary />,
  },
];

export const router = createBrowserRouter(routes);
